// Action Cable provides the framework to deal with WebSockets in Rails.
import * as ActionCable from "@rails/actioncable";
import { createConsumer } from "@rails/actioncable";

declare global {
  interface Window {
    partnerPortalCable: ActionCable.Consumer;
  }
}

export function partnerPortalCable(): ActionCable.Consumer {
  return (window.partnerPortalCable ??= createConsumer("/partner_cable"));
}
